import { capitalizeFirstLetter } from "./capitalizeFirstLetter"

export const parseSystemType = (systemType: string | undefined) => {
  if (!systemType) return ""

  return capitalizeFirstLetter(systemType.replaceAll("_", " ") || "")
}
